import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createInvitation,
  DIAM_API_PATH,
  getInvitationLink,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';
import type { InviteMemberFormData } from './types';

export interface CreateInvitationResult {
  link: string;
  data: InviteMemberFormData;
}

export function useCreateInvitation() {
  const { getIdToken, apiUrl } = useApiEssentials(DIAM_API_PATH);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      data: InviteMemberFormData,
    ): Promise<CreateInvitationResult> => {
      const idToken = await getIdToken();
      const response = await createInvitation(apiUrl, idToken, {
        email: data.email.trim(),
        teamId: data.teamId,
        roleIds: data.roles,
      });

      const created = response.invitations?.[0];
      if (!created?.id) {
        return { link: '', data };
      }

      const linkResponse = await getInvitationLink(apiUrl, idToken, created.id);

      return {
        link: linkResponse.link,
        data,
      };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['diam', 'invitations'] });
      queryClient.invalidateQueries({
        queryKey: ['diam', 'invitations', 'pending-count'],
      });
    },
  });
}
